module.exports = __webpack_public_path__ + "img/Transpordiamet_vapp_must_est.fb84185b.svg";